<template>
  <div id="ConfirmationModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content first-modal-content">
        <div class="modal-header scnd-cancelModal-bgcolor">
          <button type="button" class="close" @click="closePopup" data-target="#ConfirmationModal">
            &times;
          </button>
          <div class="modal-title service-modal-title">
            <div class="cancel-successful">Cancellation request</div>
            <div class="process-cancel">Please allow 24-48 hours to process your cancellation.</div>
            <hr class="process-hr-line" />
          </div>
        </div>
        <div class="modal-body">
          <p class="scnd-modal-service">Thanks for trying out this service.</p>
          <p class="scnd-service-para">
            To help improve our services for the future, let us know why this service wasn’t right
            for you.
          </p>
          <div class="textarea-field">
            <p>Reason:</p>
            <textarea cols="30" rows="2" v-model="reason"></textarea>
          </div>
        </div>
        <div class="modal-footer cancelModal-bgcolor">
          <button class="btn emergo-blue-button center-block submit-btn" @click="requestCancel">
            Submit
          </button>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import $ from 'jquery';
import Loader from '../../UIComponents/Loader.vue';
import { postPlan, getAddonDetails } from '../../../apis/psm';

export default {
  props: ['selectedService'],
  components: { Loader },
  data() {
    return {
      reason: '',
      selectedRecords: {},
      options: [
        {
          name: '250 & 2GB',
          desc: 'Free',
          value: 250,
          storage: '2097152',
          price: '0',
        },
        {
          name: '1000 & 4GB',
          desc: '+$200',
          value: 1000,
          storage: '4194304',
          price: '200',
        },
        {
          name: '2000 & 6GB',
          desc: '+$300',
          value: 2000,
          storage: '6291456',
          price: '300',
        },
        {
          name: '3000 & 8GB',
          desc: '+$400',
          value: 3000,
          storage: '8388608',
          price: '400',
        },
        {
          name: '4000 & 10GB',
          desc: '+$500',
          value: 4000,
          storage: '10485760',
          price: '500',
        },
        {
          name: '5000 & 12GB',
          desc: '+$600',
          value: 5000,
          storage: '12582912',
          price: '600',
        },
      ],
      records: {},
      loaderStatus: false,
    };
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    closePopup() {
      this.reason = '';
      $('#ConfirmationModal').modal('hide');
    },

    async getAddons() {
      const addonDetails = await getAddonDetails(
        JSON.parse(localStorage.getItem('userData')).account_id
      );
      const index = addonDetails.findIndex((addon) => addon.units === 'RECORDS');
      if (index >= 0) {
        this.records = addonDetails[index];
        const totalLimit = this.records.total_limit;
        if (totalLimit <= 250) {
          [this.selectedRecords] = this.options;
        } else if (totalLimit > 250 && totalLimit <= 1000) {
          [, this.selectedRecords] = this.options;
        } else if (totalLimit > 1000 && totalLimit <= 2000) {
          [, , this.selectedRecords] = this.options;
        } else if (totalLimit > 2000 && totalLimit <= 3000) {
          [, , , this.selectedRecords] = this.options;
        } else if (totalLimit > 3000 && totalLimit <= 4000) {
          [, , , , this.selectedRecords] = this.options;
        } else if (totalLimit > 4000 && totalLimit <= 5000) {
          [, , , , , this.selectedRecords] = this.options;
        }
      }
    },
    async requestCancel() {
      let response;
      if (this.reason) {
        this.loaderStatus = true;
        const addon = [];
        if (
          this.selectedService.id === 1 ||
          this.selectedService.id === 13 ||
          this.selectedService.id === 14
        ) {
          addon.push({
            account: false,
            active: true,
            id: 2,
            price: this.selectedRecords.price,
            valid_from: moment(this.selectedService.valid_from).format(
              'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
            ),
            valid_until: moment(this.selectedService.valid_until).format(
              'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
            ),
            volume: this.selectedRecords.storage,
          });
          addon.push({
            account: false,
            active: true,
            id: 3,
            price: this.selectedRecords.price,
            valid_from: moment(this.selectedService.valid_from).format(
              'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
            ),
            valid_until: moment(this.selectedService.valid_until).format(
              'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
            ),
            volume: this.selectedRecords.value,
          });
        }
        const formData = {
          account_id: JSON.parse(localStorage.getItem('userData')).account_id,
          active: true,
          operation: 10,
          add_on: addon,
          payment_mode: 4,
          plan_id: this.selectedService.id,
          plan_price: 0,
          service_type: 'premium',
          total_amount: 0,
          valid_from: moment(this.selectedService.valid_from).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          valid_until: moment(this.selectedService.valid_until).format(
            'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
          ),
          reason_for_cancel: this.reason,
        };
        response = await postPlan(formData);
        this.loaderStatus = false;
        if (response.message === 'success' && response.status_code === 200) {
          this.closePopup();
          this.clearNotifications();
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'Your subscription cancel request successful',
            group: 'custom-notification',
          });
        } else {
          this.clearNotifications();
          this.$notify({
            type: 'error',
            title: 'Error',
            text: response.data,
            group: 'custom-notification',
          });
        }
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Please mention reason for cancellation',
          group: 'custom-notification',
        });
      }
    },
  },
  mounted() {
    this.getAddons();
  },
};
</script>

<style lang="scss" scoped>
.modal-header {
  .close {
    background: none;
    opacity: 0.5;
    height: 17px;
    color: $deep-gray !important;
    width: 17px;
    border-radius: $radius20;
    @include fontItems($font-32, 17px, $font-weight-small);
    outline: none;
  }
  &.cancelModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
  }
  &.scnd-cancelModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
    padding-bottom: 0px;
  }
  &.upgradeModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
  }
}
.modal-footer {
  &.cancelModal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: $radius10;
    padding-bottom: 32px;
  }
}
.submit-btn {
  padding: 7px 41px 11px;
}
.modal-content {
  &.first-modal-content {
    border-radius: 12px;
  }
}
.modal-title {
  &.service-modal-title {
    text-align: center;
  }
}
.cancel-successful {
  padding-top: 16px;
  @include fontItems($font-28, 33px, $font-weight-medium);
  color: $light-green;
}
.process-cancel {
  @include fontItems($font-18, 21px, $font-weight-medium);
  color: $deep-gray;
  padding-top: 16px;
}
.scnd-modal-service {
  font-size: $font-24;
  line-height: 28px;
  text-align: center;
  color: #133d5f;
}
.process-hr-line {
  margin-bottom: 0px;
}
.scnd-service-para {
  padding: 6px 121px;
  font-size: $font-16;
  line-height: 19px;
  text-align: center;
  color: $dark-black-alpha;
}
.textarea-field {
  text-align: center;
  textarea {
    background: $deep-white;
    border: 0.5px solid $deep-gray;
    box-sizing: border-box;
    border-radius: 7px;
  }
}
div#ConfirmationModal {
  background-color: rgba(0, 0, 0, 0.6);
}
</style>
